import React, { Component } from "react";
import { connect } from "react-redux";

class ClassC000123 extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  render() {
    return <div>建構中</div>;
  }
}

export default connect((state) => ({ user: state.user }), {})(ClassC000123);
